import { render, staticRenderFns } from "./SVGPutToTemplateModal.vue?vue&type=template&id=676d05f6"
import script from "./SVGPutToTemplateModal.vue?vue&type=script&lang=js"
export * from "./SVGPutToTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./SVGPutToTemplateModal.vue?vue&type=style&index=0&id=676d05f6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676d05f6')) {
      api.createRecord('676d05f6', component.options)
    } else {
      api.reload('676d05f6', component.options)
    }
    module.hot.accept("./SVGPutToTemplateModal.vue?vue&type=template&id=676d05f6", function () {
      api.rerender('676d05f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SVGPutToTemplateModal.vue"
export default component.exports